export const colors = {
  navy: '#161345',
  orange: '#FF7F00',
  lightGrey: '#EBEBEB',
  teal: '#60C4BF'
}
